import { Component } from '@angular/core';

@Component({
  selector: 'ebw-monorepo-controlli',
  templateUrl: './controlli.component.html',
  styleUrls: ['./controlli.component.scss']
})
export class ControlliComponent {
  // il tab-group non è lazy: RischioAnaliticoComponent (dentro "Visualizzazione") esiste già
  // mentre "Caricamenti" è attivo, gli serve sapere quando è davvero visibile per pilotare
  // la larghezza del pannello solo mentre lo è (vedi RischioAnaliticoComponent.isActive)
  outerTabIndex = 0;
}
